import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Settings, SettingsService} from './settings.service';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable()
export class SettingsResolver implements Resolve<Settings> {

  constructor(private service: SettingsService) {
  }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<Settings> | Promise<Settings> | Settings {
    return this.service.fetch();
  }
}
